export default __webpack_public_path__ + "static/O0097-510d9263a87439ca81f2fdcd36d401e6.png";